"use client";
import { useState } from 'react';
import Image from 'next/image';

export default function OrgChartPage() {
  const [selectedRole, setSelectedRole] = useState(null);

  return (
    <div className="bg-gray-50 pt-10 pb-6 sm:pb-10">
      <div className="max-w-6xl mx-auto px-4">
        <h1 className="text-2xl sm:text-4xl font-bold text-center mb-6 sm:mb-8 text-green-800">
          Organizational Structure
        </h1>

        {/* Image Container with Responsive Aspect Ratio */}
        <div className="relative w-full aspect-[16/9] bg-white rounded-xl shadow-lg overflow-hidden">
          <Image
            src="/images/about/bgcompanystru.png"
            alt="Company Organizational Structure"
            fill
            className="object-contain"
            priority
          />
        </div>
      </div>
    </div>
  );
}
